const CryptoJS = require('crypto-js');
 
const keyValue = 'ThisIsASecretKey'; // Replace with your actual key
const algorithm = 'AES'; // AES is the algorithm used
 
function generateKey() {
  return CryptoJS.enc.Utf8.parse(keyValue);
}
 
export const   decrypt = (encryptedData) =>{
  const key = generateKey();
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export const encrypt = (plainText) => {
  const key = generateKey();
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString(); // Base64 string
}
 
// Example usage
// const  encryptedData = 'jYb/d7TmStKEUG9bzb468hO3UdGVbsRZkgX+6ARuci049VdqznZ9RYQbrbmF45Fk1KP0bfXF+ah3xgnwDJ8Iydyx5jX4Smwi/8CfqrIIFSlZhThuDGeuJpeu6y9WM/f65Lotbs+IApSs26zCGRfyIgLMT+RjXwfUtqIhmEIPhEA='; // Replace with your actual encrypted data
// const decryptedData = decrypt(encryptedData);
